interface TeamsTableHeaderProps {
  shouldDisplayFormColumn: boolean;
}

export default function TeamsTableHeader({ shouldDisplayFormColumn }: TeamsTableHeaderProps) {
  return (
    <>
      <div></div>
      <span className="text-right font-robotoMedium font-medium text-[10px] leading-[16px] text-pmw-label-tertiary-light dark:text-pmw-label-tertiary-dark">
        #
      </span>
      <span className="font-robotoRegular font-normal text-[10px] leading-[16px] text-pmw-label-tertiary-light dark:text-pmw-label-tertiary-dark">
        Teams
      </span>
      <span className="text-center font-robotoRegular font-normal text-[10px] leading-[16px] text-pmw-label-tertiary-light dark:text-pmw-label-tertiary-dark">
        PL
      </span>
      <span className="text-center font-robotoRegular font-normal text-[10px] leading-[16px] text-pmw-label-tertiary-light dark:text-pmw-label-tertiary-dark">
        V
      </span>
      <span className="text-center font-robotoRegular font-normal text-[10px] leading-[16px] text-pmw-label-tertiary-light dark:text-pmw-label-tertiary-dark">
        D
      </span>
      <span className="text-center font-robotoRegular font-normal text-[10px] leading-[16px] text-pmw-label-tertiary-light dark:text-pmw-label-tertiary-dark">
        L
      </span>
      <span className="text-center font-robotoRegular font-normal text-[10px] leading-[16px] text-pmw-label-tertiary-light dark:text-pmw-label-tertiary-dark">
        Pts
      </span>
      {shouldDisplayFormColumn && (
        <span className="text-center font-robotoRegular font-normal text-[10px] leading-[16px] text-pmw-label-tertiary-light dark:text-pmw-label-tertiary-dark">
          Form
        </span>
      )}
    </>
  );
}
